import { Container, styled } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { variables } from '../common/styles';

export const IdentityProofingFailure = () => (
  <Container maxWidth="xl" style={{ padding: 0 }}>
    {/* <Wrapper>
      <Error>{config.idproofingfailure}</Error>
      <ErrorIcon />
    </Wrapper> */}
    <Wrapper>
      <h1>
        <FontAwesomeIcon
          icon={faCircleExclamation}
          size="1x"
          fixedWidth
          style={{ color: variables.brandDanger }}
        />
        We can't sign you in
      </h1>
      <p style={{ backgroundColor: '#f4e3db', padding: '16px' }}>
        We're sorry, but you were unable to verify you identity through
        Login.gov. This may be due to a variety of reasons, such as incorrect
        information or technical difficulties. Please choose one of the
        following options to proceed:
      </p>
      <h1>What you can do:</h1>
      <p>
        For problems with your Login.gov account, please review{' '}
        <a href="https://www.login.gov/help/" target="_blank" rel="noreferrer">
          Login.gov's Help Section
        </a>{' '}
        or contact them at{' '}
        <a
          href="https://www.login.gov/contact/"
          target="_blank"
          rel="noreferrer">
          login.gov/contact.
        </a>
      </p>
    </Wrapper>
  </Container>
);

const Wrapper = styled('article')(({ theme }) => ({
  fontSize: '1.5em',

  '& >*+*': {
    marginTop: theme.spacing(2),
  },
}));
